export const profile = {
  name: 'Mohit Jangra',
  role: 'Full Stack Developer',
  headline: 'Building Secure, Scalable Full-Stack Applications.',
  subHeadline: 'MERN Stack Specialist | Next.js | System Architecture',
  location: 'India',
  photo: 'https://github.com/mohitjangra19.png',
  summary:
    'Full Stack Developer with production experience in building secure, high-performance web applications. impactful solutions using modern tech stacks.',
  email: 'mjsg46000@gmail.com',
  phone: null,
  resumeUrl: '/Mohit_Jangra_Resume.pdf',
  socials: {
    github: 'mohitjangra19',
    linkedin: 'https://www.linkedin.com/in/mohit-jangra-255764261/',
    twitter: 'https://x.com/MohitJangr75556',
    website: 'https://portfolio-t2uf.vercel.app/',
  },
};

export const projects = [
  {
    title: 'Gurugram University Portal',
    description: 'Secure Attendance System with Role-Based Access Control.',
    problem: 'Manual attendance tracking was inefficient and prone to errors. Data privacy was a concern.',
    solution: 'Built a secure attendance system using Node.js, MongoDB, and JWT with Role-Based Access Control (RBAC).',
    result: 'Solved data privacy issues and streamlined the attendance process for university staff and students.',
    tech: ['Node.js', 'MongoDB', 'JWT', 'RBAC'],
    live: '#',
    repo: '#',
  },
  {
    title: 'Mhakana Buzz (E-commerce)',
    description: 'D2C platform for SEO and Secure Payment Gateway.',
    problem: 'Needed a high-performance, SEO-friendly e-commerce platform with secure payments.',
    solution: 'Developed a D2C platform using Next.js for SSR/SEO and integrated a Secure Payment Gateway.',
    result: 'Delivered a fast, secure shopping experience, improving search visibility and user trust.',
    tech: ['Next.js', 'Payment Gateway', 'SEO', 'React'],
    live: '#',
    repo: '#',
  },
];

export const whyHireMe = [
  {
    title: 'Production-Grade Experience',
    description: 'Unlike many freshers, I have delivered live functionality for real clients, not just toy projects.',
  },
  {
    title: 'Deadline Delivery',
    description: 'Proven track record of managing timelines and delivering quality code on schedule.',
  },
  {
    title: 'Performance Optimization',
    description: 'Experience in optimizing page load times (e.g., 20% improvement at Riseinnotech).',
  }
];

export const education = [
  {
    institution: 'University of Example',
    degree: 'Bachelor of Science in Computer Science',
    period: '2018 — 2022',
    points: [
      'Graduated with honors, GPA 3.8/4.0.',
      'Relevant coursework: Data Structures, Algorithms, Web Development.',
      'Led a team project on building a full-stack web application.',
    ],
  },
  {
    institution: 'High School Example',
    degree: 'High School Diploma',
    period: '2014 — 2018',
    points: [
      'Focused on STEM subjects, particularly mathematics and computer science.',
      'Participated in coding competitions and hackathons.',
    ],
  },
];

export const experience = [
  {
    company: 'Freelance',
    title: 'Full Stack Developer',
    period: 'Present',
    points: [
      'Delivered live client projects including Gurugram University Portal and Mhakana Buzz.',
      'Specialized in MERN stack development and secure authentication systems.',
    ],
  },
  {
    company: 'Riseinnotech',
    title: 'Intern',
    period: 'Past',
    points: [
      'Optimized page load/rendering performance by 20%.',
      'Collaborated with senior developers to implement best practices.',
    ],
  },
];
